import * as React from 'react';
export const IcServerShared = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M20.5 13a1.46 1.46 0 00-.55.11L17.74 12 20 10.89c.174.072.361.11.55.11a1.5 1.5 0 10-1.44-1.9l-3 1.51a1.46 1.46 0 00-.55-.11 1.5 1.5 0 100 3c.189 0 .375-.038.55-.11l3 1.51A1.5 1.5 0 1020.5 13zm-15-2h6.59A6 6 0 0118 6h3.65a3.49 3.49 0 00-3.15-2h-13a3.5 3.5 0 100 7zm4-4.5a1 1 0 110 2 1 1 0 010-2zm-4 0a1 1 0 110 2 1 1 0 010-2zm6.59 6.5H5.5a3.5 3.5 0 100 7h13a3.49 3.49 0 003.15-2H18a6 6 0 01-5.91-5zM5.5 17.5a1 1 0 110-2 1 1 0 010 2zm4 0a1 1 0 110-2 1 1 0 010 2z'
      fill='currentColor'
    />
  </svg>
);
